d<template>
  <div id="app" v-if="ui.header">
    <LopeHeader></LopeHeader>
    <div class="clearfix">
    </div>
    <!-- BEGIN CONTAINER -->
    <div class="page-container">
      <LopeSidebar></LopeSidebar>
      <router-view></router-view>
    </div>
    <!-- END CONTAINER -->
    <LopeFooter></LopeFooter>
    <!-- BEGIN COMMON MODAL DAILOG -->
    <bootstrap-modal ref="modal" :title="ui.title" id="global-btmodal">
      <component slot="body" :is="ui.currentView">
        <!-- 组件在 vm.ui.currentview 变化时改变！ -->
      </component>
    </bootstrap-modal>
    <!-- END COMMON MODAL DAILOG -->
  </div>
  <div id="app" v-else>
    <router-view></router-view>
  </div>
</template>

<script>
import LopeHeader from './components/layout/header.vue'
import LopeSidebar from './components/layout/sidebar.vue'
import LopeFooter from './components/layout/footer.vue'
import {MSG_ID, OP_TYPE, DEFAULT_EXPIRE, K_LOGINED_USER} from './lib/constant'
import mixins from './mixins/index'
import BootstrapModal from './components/fragment/BootstrapModal.vue'
import db from './store/local.js'
import http from './lib/utils/request.js'
import common from './lib/methods/common.js'

export default {
  mixins: mixins,
  components: {
    LopeHeader,
    LopeSidebar,
    LopeFooter,
    BootstrapModal
  },
  data () {
    return {
      user: this.$store.state.user,
      propCount: this.$store.getters.propCount,
      ui: {
        title: '',
        currentView: '',
        header: false
      },
      biz: {
        loginUrl: '/#/login'
      }
    }
  },
  methods: {
    setEnv () {
      this.ui.header = this.logined
      // Authentication
      if (this.logined) {
        let sUser = db.get(K_LOGINED_USER)
        this.$store.dispatch('setAuthedActions', {authedActions: sUser.account.permissions})
      } else {
        window.emitter.emit(MSG_ID.MSG_SYS_EXIT)
      }
    }
  },
  computed: {
    logined () {
      let sUser = db.get(K_LOGINED_USER)
      console.log(sUser)
      return (sUser && sUser.account && (sUser.lastLoginTime + DEFAULT_EXPIRE > Date.now() / 1000))
    }
  },
  created () {
    this.$router.afterEach((to, from) => {
      window.emitter.emit(MSG_ID.MSG_UI_FIX_CONTENT_HEIGHT)
    })
    this.$router.beforeEach((to, from, next) => {
      window.emitter.emit(MSG_ID.MSG_UI_FIX_CONTENT_HEIGHT)
      next()
    })
    window.emitter.on(MSG_ID.MSG_UI_TOAST_ERR, (...args) => {
      let tip = args[0]
      let desc = args[1]
      window.top.swal(tip, desc, 'error')
    })
    window.emitter.on(MSG_ID.MSG_UI_TOAST_SUCC, (...args) => {
      let tip = args[0]
      let desc = args[1]
      window.top.swal(tip, desc, 'success')
    })
    window.emitter.on(MSG_ID.MSG_UI_TOAST_INFO, (...args) => {
      let tip = args[0]
      let desc = args[1]
      window.top.swal(tip, desc, 'info')
    })
    window.emitter.on(MSG_ID.MSG_UI_CONFIRM, (...args) => {
      let text = args[0]
      let succCallback = args[1]
      let cancelCallback = args[2]
      window.swal({
        title: '你确定要操作?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false
      }, function (isConfirm) {
        if (isConfirm === true) {
          if (typeof succCallback === 'function') { succCallback(args) }
        } else if (isConfirm === false) {
          if (typeof cancelCallback === 'function') { cancelCallback(args) }
        } else {
          // Esc, close button or outside click
          // isConfirm is undefined
        }
      })
    })
    window.emitter.on(MSG_ID.MSG_SYS_NAVIGATION_REPLACE, (...args) => {
      let location = args[0]
      console.log('replace' + location)
      let onComplete = args[1]
      let onAbort = args[2]
      this.$router.replace(location, onComplete, onAbort)
    })
    window.emitter.on(MSG_ID.MSG_SYS_NAVIGATION_PUSH, (...args) => {
      let location = args[0]
      let onComplete = args[1]
      let onAbort = args[2]
      this.$router.push(location, onComplete, onAbort)
    })
    window.emitter.on(MSG_ID.MSG_SYS_NAVIGATION_GO, (...args) => {
      let num = +args[0]
      this.$router.go(num)
    })
    window.emitter.on(MSG_ID.MSG_UI_SHOW_MODAL, (...args) => {
      let comp = args[0]
      let options = args[1]
      this.ui.currentView = comp
      this.ui.title = options ? options.title : ''
      // Wait for node update
      setTimeout(() => { this.$refs.modal.show(options) }, 300)
    })
    window.emitter.on(MSG_ID.MSG_UI_HIDE_MODAL, (...args) => {
      this.ui.currentView = null
      let options = args[0]
      this.$refs.modal.hide(options)
    })
    window.emitter.on(MSG_ID.MSG_UI_FIX_CONTENT_HEIGHT, (...args) => {
      setTimeout(() => {
        return window.Layout && window.Layout.fixContentHeight()
      }, 50)
    })
    window.emitter.on(MSG_ID.MSG_SYS_LOCAL_SESSION_SET, (...args) => {
      let opType = args[0]
      let key = args[1]
      let val = args[2]
      let result = null
      switch (opType) {
        case OP_TYPE.C:
        case OP_TYPE.U:
          db.save(key, val)
          break
        case OP_TYPE.D:
          db.delete(key)
          break
        case OP_TYPE.R:
          result = db.get(key)
          break
      }
      window.emitter.emit(MSG_ID.MSG_SYS_LOCAL_SESSION_RESULT, opType, result)
    })
    window.emitter.on(MSG_ID.MSG_SYS_EXIT, (...args) => {
      db.delete(K_LOGINED_USER)
      this.ui.header = false
      window.location.href = this.biz.loginUrl
    })
    window.emitter.on(MSG_ID.MSG_SYS_CHECK_SESSION, (...args) => {
    })
    window.emitter.on(MSG_ID.MSG_SYS_REAUTH, (...args) => {
      let user = db.get(K_LOGINED_USER)
      http.post('auth.login', {
        account: user.account.username,
        pwd: user.accountPwd,
        application_id: user.account.application_id
      }, {}, (res) => {
        window.emitter.emit(MSG_ID.MSG_SYS_REAUTH_SUCCESS, res)
      }, (state) => {
        window.emitter.emit(MSG_ID.MSG_SYS_REAUTH_FAIL, state)
      })
    })
    window.emitter.on(MSG_ID.MSG_SYS_REAUTH_SUCCESS, (...args) => {
      let res = args[0]
      let oldUser = db.get(K_LOGINED_USER)
      let user = {
        application_id: 1,
        account: res.account,
        session: res.session,
        accountPwd: oldUser.accountPwd,
        lastLoginTime: Date.now() / 1000 + 3600
      }
      db.save(K_LOGINED_USER, user)
      common.delUserCache()
    })
    window.emitter.on(MSG_ID.MSG_SYS_REAUTH_FAIL, (...args) => {
      console.log('reauth fail!')
    })
    window.emitter.on(MSG_ID.MSG_UI_TIP, (...args) => {
      let type = args[0]
      let msg = args[1]
      let title = args[2]
      window.toastr.options = {
        closeButton: true,
        debug: false,
        positionClass: 'toast-top-right',
        onclick: null,
        showDuration: '1000',
        hideDuration: '1000',
        timeOut: '5000',
        extendedTimeOut: '1000',
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut'
      }
      window.toastr[type](msg, title)
    })
    window.emitter.on(MSG_ID.MSG_UI_TIP_SUCC, (...args) => {
      window.emitter.emit(MSG_ID.MSG_UI_TIP, 'success', ...args)
    })
    window.emitter.on(MSG_ID.MSG_UI_TIP_INFO, (...args) => {
      window.emitter.emit(MSG_ID.MSG_UI_TIP, 'info', ...args)
    })
    window.emitter.on(MSG_ID.MSG_UI_TIP_ERR, (...args) => {
      window.emitter.emit(MSG_ID.MSG_UI_TIP, 'error', ...args)
    })
    window.emitter.on(MSG_ID.MSG_UI_TIP_WARN, (...args) => {
      window.emitter.emit(MSG_ID.MSG_UI_TIP, 'warning', ...args)
    })
    window.emitter.on(MSG_ID.MSG_UI_INFLATE_SELECT2, (...args) => {
      console.log('abc.....')
      let elemId = args[0]
      if (!elemId) {
        return
      }
      if (!elemId.startsWith('#')) {
        elemId = '#' + elemId
      }
      window.$(elemId).select2({
        placeholder: '请选择一项',
        allowClear: true
      })
    })
  },
  mounted () {
    this.setEnv()
  }
}
</script>

<style scoped>
.top-tip {
  float: left;
  top: 0;
  left: 0;
  z-index: 20000;
  background-color: #f00;
}
</style>



// WEBPACK FOOTER //
// App.vue?df0557fa